import React from 'react';
import Helmet from 'react-helmet';

export default class Error404 extends React.Component {
  render() {
    return (
      <div className="page">
        <Helmet
          title="Page not found"
          meta={[{ property: 'og:title', content: 'Page not found' }]}
        />
        <header className="error-header">
          <h1 className="error-title">Page not found.</h1>
        </header>
        <p className="error-body">Are you making things up?</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/404.js